import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header/header.component';
import { MediaListComponent } from '../pages/media/media-list/media-list.component';
import { AppRoutingModule } from './layout-routing.module';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    MainLayoutComponent,
    HeaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    AppRoutingModule ,
    SharedModule
  ],
  exports: [
    HeaderComponent,
    MainLayoutComponent
  ]
})
export class LayoutModule { }
